module.exports = __webpack_public_path__ + "static/media/change-status.57d0d3dd.png";